import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

import * as icons from "../../../../resources/icons";
import Badge from "../../components/Badge/Badge";
import Button from "../../components/Button/Button";
import FilterModal from "../../components/FilterModal/FilterModal";
import FilterModalCustomContent from "../../components/FilterModal/FilterModalCustomContent";
import Headline from "../../components/Headline/Headline";
import Icon from "../../components/Icon/Icon";
import Paragraph from "../../components/Paragraph/Paragraph";
import TileIconButton from "../../components/TileIconButton/TileIconButton";
import { useAppHistory } from "../../libs/hooks/use-app-routing";
import { ROUTES } from "../../routes";
import { useTrackingContext } from "../utils/tracking-context";

type Props = Pick<ComponentProps<typeof FilterModal>, "alignPosition" | "title"> & {
  hasCallToAction: boolean;
  onClose: () => void;
  onDismiss: () => void;
};

const AvailabilityFilterTeaserModalPartial = ({ alignPosition, title, hasCallToAction, onClose, onDismiss }: Props) => {
  const { t } = useTranslation(["commons"]);
  const history = useAppHistory();
  const { mixpanel } = useTrackingContext();

  return (
    <FilterModal
      alignPosition={alignPosition}
      title={title}
      badge={<Badge size="s" variant="accent" label={t("commons:defaults.new")} />}
      closeButton={<TileIconButton icon={<Icon source={icons.IconSmallCross} />} onClick={onClose} />}
    >
      <FilterModalCustomContent>
        <Headline>{t("commons:availabilityFilterTeaserModalPartialProductFinder.headline")}</Headline>
        <Paragraph>
          {hasCallToAction
            ? t("commons:availabilityFilterTeaserModalPartialProductFinder.description")
            : t("commons:availabilityFilterTeaserModalPartialProductFinder.descriptionWithoutCallToAction")}
        </Paragraph>
        {hasCallToAction && (
          <Button
            block
            variant="accent"
            kind="solid"
            onClick={() => {
              mixpanel?.trackAvailabilityFilterTeaserCtaClicked();
              history.push(ROUTES.SETTINGS.ASSORTMENT_INDEX);
            }}
            icon={<Icon source={icons.IconSmallArrowRight} />}
            iconRight
          >
            {t("commons:availabilityFilterTeaserModalPartialProductFinder.activateAssortmentButton")}
          </Button>
        )}
        <Button
          block
          variant="standout"
          kind="solid"
          classNames={["u-space-top-s"]}
          onClick={() => {
            onClose();
            onDismiss();
          }}
          icon={<Icon source={icons.IconSmallCross} />}
        >
          {t("commons:availabilityFilterTeaserModalPartialProductFinder.notShowAgainButton")}
        </Button>
      </FilterModalCustomContent>
    </FilterModal>
  );
};

export default AvailabilityFilterTeaserModalPartial;
